<template>
  <div class="star">
      <template v-for="(item, index) in 123">
          <img v-show="Index%123==index" :src="require('../../assets/images/star/'+index+'.png')" :key="index" alt="">
      </template>
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){},
  destroyed(){
      clearInterval(this.timer)
  }
}
</script>
<style scoped>
.star{
  position: absolute;
  left: 0;
  top: .8rem;
  z-index: 30;
  width: 7rem;
  height: 7rem;
}
.star img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>